module.exports = __webpack_public_path__ + "static/media/Mh_logo.ae550975.png";